import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '@app/app.config.provider';
import { IProductObservationDates } from '@models/product';
import { StoreActions } from '@models/store/store-actions';
import { IStoreState } from '@models/store/store-state';
import { ObservableStore } from '@services/observable-store/dist';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ObservationDatesService extends ObservableStore<IStoreState> {
  private apiObservationDate: string;

  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfigProvider) {
    super({ trackStateHistory: false });

    this.appConfig.environment.subscribe(env => {
      this.apiObservationDate = `${env.API.REFERENCE_DATA}/api/observationdate`;
    });
  }

  public getLastObservationDate(): Observable<Date> {
    const state = this.getState();

    if (state && state.lastObservationDate) {
      return of(state.lastObservationDate);
    } else {
      return this.fetchLastObservationDate();
    }
  }

  private fetchLastObservationDate(): Observable<Date> {
    return this.http.get(`${this.apiObservationDate}/last`).pipe(
      map((res: { LastObservationDate: string }) => {
        let lastObservationDate = null;
        if (res.LastObservationDate !== null) {
          lastObservationDate = new Date(res.LastObservationDate);
        }
        this.setState({ lastObservationDate }, StoreActions.SetLastObservationDate);
        return lastObservationDate;
      }),
      catchError(err => {
        return this.handleError(err);
      })
    );
  }

  public getProductsObservationDates(): Observable<IProductObservationDates[]> {
    return this.fetchProductObservationDates();
  }

  private fetchProductObservationDates(): Observable<IProductObservationDates[]> {
    return this.http.get<IProductObservationDates[]>(`${this.apiObservationDate}`).pipe(
      map(prods => {
        const productObservationDates = (prods || []).map(pr => ({
          ProductId: pr.ProductId,
          FirstObservationDate: new Date(pr.FirstObservationDate),
          LastObservationDate: new Date(pr.LastObservationDate)
        }));
        this.setState({ productObservationDates }, StoreActions.SetObservationDates);
        return productObservationDates;
      }),
      catchError(err => {
        return this.handleError(err);
      })
    );
  }

  private handleError(error: any) {
    console.error('Server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Server error');
  }
}
